<template>
  <label class="emd-switcher__label" :for="id">
    <input
      class="emd-switcher"
      :class="getColor"
      type="checkbox"
      :id="id"
      :name="id"
      :checked="value"
      :disabled="disabled"
      :value="value"
      @change="$emit('change', $event.target.checked)"
    >
    <div class="emd-switcher__area"></div>
    <span class="emd-switcher__text">{{label}}</span>
  </label>
</template>

<script>
export default {
  name: 'EmdSwitcher',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    id: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: [Boolean, String],
      required: false,
      default: false
    }
  },
  computed: {
    getColor () {
      return `_color_${this.color}`
    }
  }
}
</script>
